import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export function CustomerSelectField({ customers, value, onChange, testId }) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label className="text-xs uppercase tracking-[0.05em] text-zinc-500">Customer</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="rounded-sm border-zinc-300" data-testid={testId}>
          <SelectValue placeholder="No customer" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="none">No customer</SelectItem>
          {customers.map((c) => (
            <SelectItem key={c.id} value={c.id}>
              {c.name} ({c.currency}, x{c.coefficient})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export function NewCartDialog({
  open,
  onOpenChange,
  name,
  onNameChange,
  saving,
  onSubmit,
  customers = null,
  customerId = "none",
  onCustomerChange,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="new-cart-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">New Quote</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="flex flex-col gap-3">
          <div className="flex flex-col gap-1.5">
            <Label className="text-xs uppercase tracking-[0.05em] text-zinc-500">Quote Name</Label>
            <Input
              value={name}
              onChange={(e) => onNameChange(e.target.value)}
              placeholder="e.g. Kitchen-omm"
              className="rounded-sm border-zinc-300"
              data-testid="new-cart-name-input"
              autoFocus
            />
          </div>
          {customers && (
            <CustomerSelectField
              customers={customers}
              value={customerId}
              onChange={onCustomerChange}
              testId="new-quote-customer-select"
            />
          )}
          <DialogFooter className="mt-2">
            <Button
              type="submit"
              disabled={saving || !name.trim()}
              className="rounded-sm bg-blue-600 text-white hover:bg-blue-700"
              data-testid="new-cart-submit-button"
            >
              {saving ? "Creating..." : "Create"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
